
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Checkbox } from '@/components/ui/checkbox';
import { ALL_PAGES, ROLES } from '../constants';
import { RoleAccessConfig } from '../types';

interface RoleAccessTableProps {
  accessConfig: RoleAccessConfig;
  onAccessChange: (role: string, pageId: string, hasAccess: boolean) => void;
}

export function RoleAccessTable({ accessConfig, onAccessChange }: RoleAccessTableProps) {
  return (
    <div className="border rounded-md overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[200px]">Page</TableHead>
            <TableHead className="text-center">Admin</TableHead>
            <TableHead className="text-center">Finance</TableHead>
            <TableHead className="text-center">Warehouse</TableHead>
            <TableHead className="text-center">Seller</TableHead>
            <TableHead className="text-center">Benchmark</TableHead>
            <TableHead className="text-center">Coordinator</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {ALL_PAGES.map((page) => (
            <TableRow key={page.id}>
              <TableCell className="font-medium">{page.name}</TableCell>
              {ROLES.map((role) => (
                <TableCell key={role} className="text-center">
                  <Checkbox
                    checked={(accessConfig[role] || []).includes(page.id)}
                    onCheckedChange={(checked) => {
                      onAccessChange(role, page.id, !!checked);
                    }}
                    disabled={role === 'admin' && page.id === 'dashboard'} // Admin always has access to dashboard
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
